<template>
  <div class="ls-tree-select">
    <div class="search-box">
      <el-input v-model="filterText" placeholder="请输入机构名称" clearable />
    </div>
    <div class="tree-box">
      <el-scrollbar height="100%">
        <el-tree
          ref="lsOrgTree"
          :indent="10"
          :data="treeData"
          :props="props"
          :check-strictly="true"
          show-checkbox
          :filter-node-method="filterNode"
          @check="checkChange"
        />
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import request from "../../../api/request";
export default {
  name: 'TreeSelect',
  components: {
    
  },
  data() {
    return {
      filterText: "",
      treeData: [],
      props: {
        value: "id",
        label: "name",
        children: "children"
      }
    }
  },
  mounted() {
    this.getTreeData();
  },
  watch: {
    filterText: {
      deep: true,
      handler(val) {
        this.$refs.lsOrgTree.filter(val);
      }
    },
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data[this.props.label].indexOf(value) > -1;
    },

    /*返回当前操作用户所在租户的机构树形数据*/
    async getTreeData() {
      try {
        // const { success, message, data } = await lsfetch.get(
        //   "/api-type/base/current/operate/org/tree/by-ten",
        //   {}
        // );
        const { success, message, data } = await request({
          url: "/api-type/base/current/operate/org/tree/by-ten",
          method: "get",
        });
        // const { success, message, data } = { success:false, message:"111", data:[]}
        if (!success) {
          return this.$message.error("获取机构树失败:" + message);
        }
        
        let temp = [];
        if (data && data.length) {
          temp = data;
        }
        // await this.$nextTick(() => {
        await this.$nextTick(() => {
          this.treeData = JSON.parse(JSON.stringify(temp));
        });
      } catch (e) {
        this.$message.error("获取机构树失败:" + e.message || e);
      }
    },

    /*选择树节点*/
    checkChange() {
      const nodes = (this.$refs.lsOrgTree).getCheckedNodes();
      this.$emit("select", nodes);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
